import I18n from "i18n-js";
import { Email, ErrorBox, PhoneFieldControler, TextFieldControler, } from "../../form";
import { makeImmutable, toPairs } from "../../core";
export class FODFormController {
    constructor(params) {
        var _a, _b;
        this.firstOrderDiscount = params.firstOrderDiscount;
        this.email = new TextFieldControler({
            initialValue: ((_a = this.firstOrderDiscount.email) === null || _a === void 0 ? void 0 : _a.value) || "",
            update: (value) => (this.firstOrderDiscount.email = new Email(value)),
            errorBox: new ErrorBox({
                domainObjects: [this.firstOrderDiscount],
                errorMessages: {
                    // TODO: how to translate messages properly?
                    EmailMissing: I18n.t("_common.form.errors.required"),
                    InvalidEmail: I18n.t("validations.invalid_email"),
                },
            }),
        });
        this.phone = new PhoneFieldControler({
            initialValue: ((_b = this.firstOrderDiscount.phone) === null || _b === void 0 ? void 0 : _b.value) || "",
            update: (value, country) => {
                this.firstOrderDiscount.setPhone(value, country);
            },
            errorBox: new ErrorBox({
                domainObjects: [this.firstOrderDiscount],
                errorMessages: {
                    // TODO: how to translate messages properly?
                    PhoneMissing: I18n.t("_common.form.errors.required"),
                    InvalidPhoneNumber: I18n.t("validations.invalid_phone"),
                },
            }),
        });
        makeImmutable(this);
    }
    static create(firstOrderDiscount) {
        switch (firstOrderDiscount.type) {
            case "Enabled":
                return new FODFormController({
                    firstOrderDiscount,
                });
            case "Disabled":
                return null;
        }
    }
    get fields() {
        return {
            email: this.email,
            phone: this.phone,
        };
    }
    touch() {
        toPairs(this.fields).forEach(([_, field]) => field.onBlur());
    }
}
